import InputField from '@ulta/core/components/InputField/InputField';

export default InputField;